import styled from 'styled-components';

const PageLoadingOverlayStyle = styled.div`
	--pageLoaderSize: var(--sp6x);
	--pageLoaderBorder: var(--sp1x);
	--pageLoaderColor: var(--mainColor);

	position: fixed;
	inset: 0;
	z-index: 1000000000;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.7);
	backdrop-filter: blur(2px);
	pointer-events: all;
	cursor: wait;

	.spin-loader {
		--spinLoaderSize: var(--pageLoaderSize);
		--spinLoaderBorderSize: var(--pageLoaderBorder);
		--spinLoaderBackground: var(--pageLoaderColor);
	}
`;

export default PageLoadingOverlayStyle;
